import React from "react";
import { useNavigate, useRouteError, isRouteErrorResponse } from "react-router";
import { SomethingWrong, NotFoundPage } from "@components";

export const ErrorBoundaryRouter = () => {
  const navigate = useNavigate();
  const routeError = useRouteError();
  const isTppWebForm = window.location.href.includes("web-form");

  if (
    (isRouteErrorResponse(routeError) && routeError.status === 404) ||
    (routeError instanceof Response && routeError.status === 404)
  ) {
    return (
      <NotFoundPage onGoHome={isTppWebForm ? undefined : () => navigate("/")} />
    );
  }

  const normalizedError =
    routeError instanceof Error
      ? routeError
      : isRouteErrorResponse(routeError)
        ? new Error(`${routeError.status} ${routeError.statusText}`)
        : new Error("Unknown error");

  return (
    <SomethingWrong error={normalizedError} onClose={() => navigate(-1)} />
  );
};
